<template>
  <div class="card commodity-info">
    <div class="info">
      <div class="info-header">结算信息</div>
      <van-row class="info-line" type="flex" justify="space-between">
        <div class="info-title">销售单价：</div>
        <div class="info-value">
          <span class="number">{{ $utils.amount(listingDetail.price, 2)}}</span>
          <span class="unit">元/吨</span>
        </div>
      </van-row>
      <van-row class="info-line" type="flex" justify="space-between">
        <div class="info-title">订单量：</div>
        <div class="info-value">
          <span class="number">{{orderWeight}}</span>
          <span class="unit">吨</span>
        </div>
      </van-row>
      <van-row class="info-line" type="flex" justify="space-between">
        <div class="info-title">优惠1：会员折扣：</div>
        <div class="info-value">
          <span class="number">{{ $utils.amount(priceInfo.vipBenefit, 2) }}</span>
          <span class="unit">元/吨</span>
        </div>
      </van-row>
      <van-row class="info-line" type="flex" justify="space-between">
        <div class="info-title">{{ priceInfo.promotionName }}：</div>
        <div class="info-value">
          <span class="number">{{ $utils.amount(priceInfo.promotionBenefit, 2) }}</span>
          <span class="unit">元/吨</span>
        </div>
      </van-row>
      <van-row class="info-line" type="flex" justify="space-between">
        <div class="info-title">优惠金额：</div>
        <div class="info-value">
          <span class="number">{{ $utils.amount(priceInfo.totalBenefit, 2) }}</span>
          <span class="unit">元/吨</span>
        </div>
      </van-row>
      <van-row class="info-line" type="flex" justify="space-between">
        <div class="info-title">优惠后单价：</div>
        <div class="info-value">
          <span class="number">{{ $utils.amount(priceInfo.benefitPrice, 2) }}</span>
          <span class="unit">元/吨</span>
        </div>
      </van-row>
      <van-row class="info-line" type="flex" justify="space-between">
        <div class="info-title">订单总量：</div>
        <div class="info-value">
          <span class="number">{{orderWeight}}</span>
          <span class="unit">吨</span>
        </div>
      </van-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderSettlementCard",
  props: {
    listingDetail: Object,
    orderWeight: Number,
    priceInfo: Object,
  },
  data() {
    return {};
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.card {
  margin-top: 24px;
  background: #ffffff;
  padding: 0 24px;
  font-size: 26px;

  .info {
    padding: 16px 0;

    .info-header {
      display: flex;
      justify-content: right;
      align-items: center;
      height: 88px;
      font-size: 32px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }
    }

    .info-line {
      line-height: 54px;
      color: #666666;

      .info-value {
        .number {
          color: #E12020;
        }

        .unit {
          display: inline-block;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>